var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"payment"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"payment__list"},_vm._l((_vm.paths),function(path,index){return _c('img',{key:`payment-${index}`,staticClass:"payment__image",attrs:{"src":require(`@/assets/images/payment/${path}.svg`),"alt":"image"}})}),0)])])
}
var staticRenderFns = []

export { render, staticRenderFns }